import { confirmAlert } from "react-confirm-alert";
import QRCode from 'qrcode.react';
import CloseBtn from "../components/WalletVerticalCardPdf/assets/close-btn.svg";
import React from "react";
class CommonUtils {
  static mainSiteTitle = "Camon";

  static displayConfirmAlert(
    message = "You don't have right to access this page",
    okOption = { label: "OK", className: "", onClick: () => {} },
    cancelOption = null,
    closeOnClickOutside = false
  ) {
    let listButton = [];
    okOption && listButton.push(okOption);
    cancelOption && listButton.push(cancelOption);
    confirmAlert({
      message: message,
      overlayClassName: "custom-ui",
      closeOnClickOutside: closeOnClickOutside,
      buttons: listButton
    });
  }

  static displayCustomConfirmAlert(
    message = "You don't have right to access this page",
    okOption = { label: "OK", className: "", onClick: () => {} },
    cancelOption = null,
    title = "Sign in",
    content = null,
    height = "180px",
    classNameBody = ""
  ) {
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div style={{ minHeight: height }} className={`react-confirm-alert-body ${classNameBody}`}>
            <div className="team-info-alert">
              <div className="team-info-alert-header">
                <svg role="button" onClick={() => onClose()} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd"
                        d="M2.71844 2.7185C2.97267 2.46427 3.38486 2.46427 3.63909 2.7185L17.3371 16.4165C17.5913 16.6707 17.5913 17.0829 17.3371 17.3372C17.0829 17.5914 16.6707 17.5914 16.4165 17.3372L2.71844 3.63915C2.46421 3.38492 2.46421 2.97273 2.71844 2.7185Z"
                        fill="#181818" />
                  <path fillRule="evenodd" clipRule="evenodd"
                        d="M17.3371 2.7185C17.5913 2.97273 17.5913 3.38492 17.3371 3.63915L3.63909 17.3372C3.38486 17.5914 2.97267 17.5914 2.71844 17.3372C2.46421 17.0829 2.46421 16.6707 2.71844 16.4165L16.4165 2.7185C16.6707 2.46427 17.0829 2.46427 17.3371 2.7185Z"
                        fill="#181818" />
                </svg>
                <span>{title}</span>
                <div style={{ width: 24 }} />
              </div>
              {content}
            </div>
          </div>
        );
      }
    });
  }

  static displayConfirmAlertHaveNotRightPermission(onCallback = () => {
  }) {
    confirmAlert({
      message: "You don't have right to access this page",
      overlayClassName: "custom-ui",
      closeOnClickOutside: false,
      buttons: [{ label: "OK", onClick: onCallback }],
    });
  }

  static generateQR(text) {
    return <QRCode value={text} size={120} />;
  }

  static formatCountNumber(count, t) {
    let divideNumber = 1000;
    if (count > 999) {
      let suffix = t("common.k");
      if (count >= 1000000000) {
        divideNumber = 1000000000;
        suffix = t("common.b");
      } else if (count >= 1000000) {
        divideNumber = 1000000;
        suffix = t("common.m");
      } else if (count >= 10000) {
        suffix = t("common.moreThanK");
      }
      return (count / divideNumber).toFixed(1).replace('.0', '') + suffix;
    }
    return count;
  }
}

export default CommonUtils;
